export default __webpack_public_path__ + "static/media/visa.e9b81182.svg";